export { default } from "./ConditionalScript";
